import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import addLogDocument from "../addLogDocument.js";
import { auth, dbCentral } from "../../config/FirebaseConfig.js";

/**
 * Create a document in a Firestore collection via an API endpoint.
 *
 * @param {object} ref - Data to create in the document (key-value pairs).
 * @param {string} prefix - API endpoint prefix.
 * @returns {Promise<string>} - Returns "true" on success or error details on failure.
 */
const deleteDocApi = async (ref, prefix) => {
  // extract collection and id from ref
  const collection = ref.parent.id;
  const id = ref.id;
  // Define the endpoint URL
  const token = await getOrRefreshFirebaseToken();
  const url = `${prefix}database/delete-doc`;

  // Define the request body
  const body = {
    collection: collection,
    id: id,
  };

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const start = new Date();
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });

    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    const db = getFirestore();
    const userRef = doc(dbCentral, "user", currentUser.uid);
    const userSnapshot = await getDoc(userRef);

    if (!userSnapshot.exists()) {
      return "User document not found";
    }

    const orgId = userSnapshot.get("org_id");
    const responseText = await response.text();
    const end = new Date();
    const elapsed = end - start;

    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef.id,
      orgId,
      response.status.toString(),
      "", // Additional optional fields
      "",
      JSON.stringify(body),
      responseText,
      "POST",
      elapsed
    );

    // Handle response
    if (response.ok) {
    } else {
      console.error(`Failed to create document: ${response.status}`);
      return "";
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default deleteDocApi;
